export default __webpack_public_path__ + "static/media/loader.fa03e284.gif";